import { render, staticRenderFns } from "./SupportNotificationsPage.vue?vue&type=template&id=2a6fd85d&scoped=true&"
import script from "./SupportNotificationsPage.vue?vue&type=script&lang=js&"
export * from "./SupportNotificationsPage.vue?vue&type=script&lang=js&"
import style0 from "./SupportNotificationsPage.vue?vue&type=style&index=0&id=2a6fd85d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6fd85d",
  null
  
)

export default component.exports